import { listIllegalCharacters } from "client/Api/Documents/SharePoint/sharepointDocuments";

function isValid(name: string, illegalCharacters: readonly string[]): boolean {
	return illegalCharacters.every(c => name.indexOf(c) < 0);
}

let illegalCharacters: Promise<string[]> | null = null;

async function getIllegalCharacters(): Promise<string[]> {
	if (illegalCharacters) {
		return illegalCharacters;
	}

	illegalCharacters = listIllegalCharacters();

	return illegalCharacters;
}

export {
	isValid,
	getIllegalCharacters
};
